/**
 * Edit Scheduling Array Schema
 *
 * Zod validation schema for editing multiple scheduling records
 */

import { z } from "zod";

import { editSchedulingArgsSchema } from "./edit";

/**
 * Schema for editing an array of scheduling records
 */
export const editSchedulingArgsArraySchema = z.array(editSchedulingArgsSchema);
